import { call, put, takeEvery } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { FetchYardstikReport } from 'src/constants/actionTypes'
import { ApiService, callClientSecureApi } from './api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { YardstikReport } from 'src/interfaces/yardstik'
import { captureSentryError } from 'src/utils/sentry'

interface FetchYardstikReportRequest {
  stepId: string
}

function* onFetchYardstikReport(action: AsyncAction<FetchYardstikReportRequest, YardstikReport>) {
  try {
    const { stepId } = action.payload

    const { payload }: { payload: YardstikReport } = yield call(
      callClientSecureApi,
      Endpoints.FetchYardstikReport,
      {
        method: 'POST',
        apiService: ApiService.Paraworks,
        query: {
          stepId,
        },
      },
    )

    yield put(FetchYardstikReport.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.yardstik.onFetchYardstikReport] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to fetch background check report'

    yield put(FetchYardstikReport.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* yardstikSaga() {
  yield takeEvery(FetchYardstikReport.type.REQUEST, onFetchYardstikReport)
}
